import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./UserForm.css";
import Select from "react-select";
import axios from "axios";
import { InfinitySpin } from "react-loader-spinner";
import { toast } from "react-toastify";

const UserForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [position, setPosition] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "name") setName(value);
    if (name === "email") setEmail(value);
    if (name === "number") setNumber(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        "https://app.instaconnects.com/api/v1/exams/registration",
        {
          name,
          email,
          number,
          position,
        }
      );
      if (response.status === 201) {
        toast.success("Success !");
        navigate(`/instructions/${response?.data?.data?._id}`);
        localStorage.setItem("token", response?.data?.token);
        setLoading(false);
      } else {
        toast.error("Progress failed. Please try again.");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Progress failed. Please try again.");
      setLoading(false);
    }
  };

  const positionOptions = [
    {
      value: "Customer Service Representative",
      label: "Customer Service Representative",
    },
    {
      value: "Customer Support Associate",
      label: "Customer Support Associate",
    },
    {
      value: "Customer Relationship Manager",
      label: "Customer Relationship Manager",
    },
    {
      value: "Customer Support Executive",
      label: "Customer Support Executive",
    },
    { value: "Customer Care Executive", label: "Customer Care Executive" },
    {
      value: "IT Hardware and Networking",
      label: "IT Hardware and Networking",
    },
    { value: "Video Editor", label: "Video Editor" },
    { value: "Digital Marketing", label: "Digital Marketing" },
    { value: "Social Media Marketing", label: "Social Media Marketing" },
    { value: "Web Developer", label: "Web Developer (React.js, Node.js)" },
  ];

  return (
    <div className="fullContainerRegistration">
      <div className="form-container">
        <div className="header">
          <img
            src="https://hradminpanel.instaconnects.com/assets/newLogo-Qx8rvfwM.png"
            alt="Company Logo"
            className="logo"
          />
          <h2 className="form-title">Enter Your Details</h2>
        </div>
        <form className="user-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
            value={name}
            onChange={handleChange}
            className="input-field"
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
            value={email}
            onChange={handleChange}
            className="input-field"
          />
          <input
            type="text"
            name="number"
            placeholder="Your Number"
            required
            value={number}
            onChange={handleChange}
            className="input-field"
          />
          <Select
            options={positionOptions}
            value={positionOptions.find((p) => p.value === position)}
            onChange={(e) => setPosition(e?.value || "")}
            isClearable
            placeholder="Select job position"
            className="select-field"
          />
          <div className="submit-button-container">
            {loading ? (
              <>
                <button className="submit-button-loading" disabled>
                  <InfinitySpin
                    visible={true}
                    width="80"
                    color="#fff"
                    ariaLabel="infinity-spin-loading"
                  />
                </button>
              </>
            ) : (
              <button type="submit" className="submit-button">
                Continue
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserForm;
